import { CreativityContentData, PromptCreativityContent, FormCreativityContent } from './banner-interfaces';
import { CreativityType } from './creativity-interfaces';

export const isPromptCreativity = (creativity: CreativityContentData): creativity is PromptCreativityContent =>
  'prompt' in creativity && typeof creativity.prompt === 'string';

export const isFormCreativity = <T extends CreativityType>(
  creativity: CreativityContentData
): creativity is FormCreativityContent<T> => 'config' in creativity && !('prompt' in creativity);
